export default __webpack_public_path__ + "assets/images/Payment_12.3d1401.webp";